import React from 'react';
import EventAssignmentsTable from './EventAssignmentsTable';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { sortBy } from 'lodash';
import { EVENT_ASSIGNMENTS_TABLE_MODE } from './constants/EventAssignmentsTableMode';

/**
 * @typedef {object} AtlRankingTableProps
 * @property {Array<*>} [atlSponsorRankings]
 * @property {boolean} [loading]
 * @property {*} [mode]
 * @property {(externalUserId: number, newValue: number | string | null, field: string) => void} [setATLValue]
 * @property {boolean} [canEditRanking]
 */

/**
 * @param {AtlRankingTableProps} props
 */
const AtlRankingTable = props => {
  const {
    atlSponsorRankings = [],
    loading = false,
    mode,
    setATLValue,
    canEditRanking = false
  } = props;

  const sortedData = sortBy(atlSponsorRankings, user => user.name?.toLowerCase());

  const assignmentSettingsProvider = () => ({
    takenRankings: atlSponsorRankings.map(x => x.assignmentRank).filter(rank => rank)
  });

  const rankingColumnName =
    mode === EVENT_ASSIGNMENTS_TABLE_MODE.ATL_PREFERENCES ? 'Rank' : 'Sponsor Ranking';

  return (
    <Accordion
      slotProps={{
        transition: { unmountOnExit: true }
      }}
      defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <h3>ATL Sponsor Ranking</h3>
      </AccordionSummary>
      <AccordionDetails data-testid='atl-sponsor-ranking'>
        <EventAssignmentsTable
          data={sortedData}
          mode={mode}
          assignmentSettingsProvider={assignmentSettingsProvider}
          rankingColumnName={rankingColumnName}
          setATMValue={setATLValue}
          canEditRanking={canEditRanking}
          showAssignmentRank={true}
          canAssignATMs={false}
          loading={loading}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default AtlRankingTable;
